import type { Blog } from '../types/Blog';

// Import all blog markdown files
const blogFiles = import.meta.glob('../content/blogs/*.md', { 
  query: '?raw',
  import: 'default',
  eager: true 
});

// Parse blogs from markdown files
function parseBlogs(): Blog[] {
  return Object.entries(blogFiles).map(([path, content]) => {
    // Extract id from filename (e.g., '../content/blogs/interstellar.md' -> 'interstellar')
    const id = path.split('/').pop()?.replace('.md', '') || '';
    
    // Extract frontmatter using regex
    const frontmatterMatch = (content as string).match(/---\n([\s\S]*?)\n---/);
    const frontmatter = frontmatterMatch ? frontmatterMatch[1] : '';
    
    // Parse frontmatter with improved regex patterns
    const titleMatch = frontmatter.match(/title:\s*(.*)/);
    const dateMatch = frontmatter.match(/date:\s*"([^"]*)"/);
    const descriptionMatch = frontmatter.match(/description:\s*(.*)/);
    const tagsMatch = frontmatter.match(/tags:\s*\[(.*)\]/);
    const readTimeMatch = frontmatter.match(/readTime:\s*"([^"]*)"/);

    // Extract content after frontmatter
    const blogContent = (content as string).replace(/---\n[\s\S]*?\n---/, '').trim();

    return {
      id,
      title: titleMatch ? titleMatch[1] : '',
      date: dateMatch ? dateMatch[1] : '',
      description: descriptionMatch ? descriptionMatch[1] : '',
      tags: tagsMatch ? tagsMatch[1].split(',').map(tag => tag.trim().replace(/['"]/g, '')) : [],
      readTime: readTimeMatch ? readTimeMatch[1] : '',
      content: blogContent
    };
  });
}

const blogs = parseBlogs();

export function getBlogPost(id: string): Blog | undefined {
  return blogs.find(b => b.id === id);
}

export function getAllBlogs(): Blog[] {
  return blogs;
} 